module.exports = __webpack_public_path__ + "body-special-bg-shape-04.png?73727d151b9feb7d47858d6880f8a915";